import appConfig from "../config/appConfig";
import { $crud } from "../helper/CrudFactory";

/**
 * "Kjuup weiterempfehlen" (mobile setting/recommendKjuup.js): the recommendation
 * text plus the referral link. Used by the personal settings and the side nav.
 */

const isGermanUi = () => {
  try {
    return /^(de|gsw|wae)\b/i.test(localStorage.getItem("language") || "");
  } catch (_) {
    return false;
  }
};

const pick = (strings, key, de, en, isGerm) => {
  const german = typeof isGerm === "boolean" ? isGerm : isGermanUi();
  return (strings && strings[key]) || (german ? de : en);
};

export function referralLink() {
  return appConfig.REFERRAL_URL || window.location.origin;
}

export function buildRecommendText(strings, isGerm) {
  const intro = pick(
    strings,
    "recommend_text",
    "Komm zu Kjuup, bleib in Verbindung und behalte deine Kommunikation im Griff. Bring deine Kanäle zusammen, halte Nachrichten in den richtigen Projekten und starte jeden Morgen mit einer Zusammenfassung und deinen Aufgaben – alles synchronisiert mit den Apps, die du schon nutzt. Kostenlos loslegen:",
    "Join Kjuup to stay connected and keep your communication organized. Bring your channels together, keep messages in the right projects, and start each morning with a summary and your tasks—all synced with the apps you already use. Get started for free:",
    isGerm
  );
  return `${intro} ${referralLink()}`;
}

/**
 * Shares the recommendation: the system share sheet where the browser has one,
 * else the text is copied to the clipboard, else a mail draft opens.
 * Resolves to "shared" | "cancelled" | "copied" | "mailto".
 */
export async function recommendKjuup(strings, isGerm) {
  const subject = pick(strings, "recommend_subject", "Empfehlung: Kjuup", "Recommendation: Kjuup", isGerm);
  const text = buildRecommendText(strings, isGerm);

  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({ title: subject, text });
      return "shared";
    } catch (err) {
      // The user closed the share sheet: done. Anything else (not allowed here,
      // no share target) falls through to the clipboard.
      if (err && err.name === "AbortError") return "cancelled";
    }
  }

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      $crud.notify({
        type: "success",
        message: pick(strings, "recommend_copied", "Empfehlungslink kopiert", "Referral link copied", isGerm),
      });
      return "copied";
    }
  } catch (_) {
    /* fall through to mailto */
  }

  window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
  return "mailto";
}
